"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.localizePercentage=(e,t)=>Intl.NumberFormat(e,{style:"percent",maximumFractionDigits:2}).format(t/100);
//# sourceMappingURL=percentage.js.map
